import { closePosition, ClosePositionRequest } from 'api/copyBotApi';
import { useCopyBotAuth } from 'hooks';
import { store } from 'store';

export const useClosePosition = () => {
  const { account } = store.web3Store;
  const { getAccessToken, clearAccessToken } = useCopyBotAuth();

  const closeCopiedPosition = async (payload: ClosePositionRequest) => {
    if (!account) return null;

    try {
      const token = await getAccessToken(account);
      return await closePosition(account, payload, token);
    } catch (err: any) {
      if (err?.response?.status === 401) {
        clearAccessToken(account);
      }
      console.error('Failed to close position:', err);
      return null;
    }
  };

  return closeCopiedPosition;
};
